import React from "react";

// tslint:disable: max-line-length
interface Props {
  width?: number;
  className?: string;
  title?: string;
  fill?: string;
}
export default function Télécharger(props: Props) {
  return (
    <svg
      className={props.className}
      width={props.width ? props.width + "px" : "17px"}
      height="23px"
      viewBox="0 0 26 23"
      version="1.1"
    >
      <title>Télécharger</title>
      <g
        id="BOARD-3---Icônes"
        transform="translate(-310.000000, -536.000000)"
        fill={props.fill ? props.fill : "#1B202D"}
      >
        <g id="Pictogrammes" transform="translate(305.000000, 181.000000)">
          <g id="8---Télécharger" transform="translate(5.000000, 352.000000)">
            <path
              d="M25.3112583,21.2071577 C25.6921325,21.2071577 26,21.5271567 26,21.9214412 L26,21.9214412 L26,25.2857165 C26,25.6807153 25.6921325,26 25.3112583,26 L25.3112583,26 L0.688741722,26 C0.308556291,26 1.08357767e-13,25.6807153 1.08357767e-13,25.2857165 L1.08357767e-13,25.2857165 L1.08357767e-13,21.9214412 C1.08357767e-13,21.5271567 0.308556291,21.2071577 0.688741722,21.2071577 C1.06961589,21.2071577 1.37748344,21.5271567 1.37748344,21.9214412 L1.37748344,21.9214412 L1.37748344,24.571433 L24.6225166,24.571433 L24.6225166,21.9214412 C24.6225166,21.5271567 24.9303841,21.2071577 25.3112583,21.2071577 Z M13.0866891,3 C13.4576269,3 13.7586779,3.30236659 13.7586779,3.67643533 L13.7586779,3.67643533 L13.7586779,18.6905939 L16.9728007,15.4552037 C17.2348763,15.1907175 17.6602453,15.1907175 17.9229929,15.4552037 C18.1850686,15.7190135 18.1850686,16.1471971 17.9229929,16.4116833 L17.9229929,16.4116833 L13.5617852,20.8017485 C13.4361233,20.928242 13.2647661,20.9999441 13.0866891,20.9999441 C12.908612,20.9999441 12.7372549,20.928242 12.611593,20.8017485 L12.611593,20.8017485 L8.25038524,16.4116833 C7.98763759,16.1471971 7.98763759,15.7190135 8.25038524,15.4552037 C8.51246089,15.1907175 8.93782984,15.1907175 9.20057749,15.4552037 L9.20057749,15.4552037 L12.4147002,18.6905939 L12.4147002,3.67643533 C12.4147002,3.30236659 12.7157512,3 13.0866891,3 Z"
              id="Combined-Shape"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}
